import React from "react";
import { m } from "kremling";

type TextCellProps = {
  value: React.ReactNode;
  isDisabled?: boolean;
};

export function TextCell({ value, isDisabled }: TextCellProps) {
  return (
    <span className={m("cp-data-table-cell-disabled", isDisabled)}>
      {value}
    </span>
  );
}
